<template>
  <div v-if="investment">
    <TheHeader
      with-menu
      back-route="."
    />
    <BaseSection>
      <BaseTitleGroup
        :subtitle="`${$t('My investments')} / ${participation.attributes.name}`"
        :title="`Admin ${spv.attributes.name}`"
        class="pb-8"
      />
    </BaseSection>
    <BaseSection>
      <BaseSectionHeader class="pt-4 border-t border-strong-shadow-color">
        {{ $t('Company Admin', { spv: spv.attributes.name }) }}
      </BaseSectionHeader>
      <BaseMenuList
        :items="transformDocuments(companyAdminDocuments)"
        class="mb-4"
      >
        <div
          key="captable"
          :class="{'border-b': transformDocuments(companyAdminDocuments).length !== 0 }"
          class="text-lg font-sans-medium pb-3 pt-4 border-shadow-color cursor-pointer"
        >
          <a
            :href="captableUrl"
            target="_blank"
          >
            Captable
          </a>
        </div>
      </BaseMenuList>

      <BaseSectionHeader class="pt-4 border-t border-strong-shadow-color">
        {{ $t('Financial Statements', { spv: spv.attributes.name }) }}
      </BaseSectionHeader>
      <BaseMenuList
        v-if="financialStatementDocuments.length"
        :items="transformDocuments(financialStatementDocuments)"
        class="mb-4"
      />
      <BaseEmptyState
        v-else
        :src="image"
        class="pt-3"
      >
        {{ $t('Financial statement empty state', { spv: spv.attributes.name }) }}
      </BaseEmptyState>

      <BaseSectionHeader class="pt-4 border-t border-strong-shadow-color">
        {{ $t('Operations documents') }}
      </BaseSectionHeader>
      <BaseMenuList
        v-if="operationsDocuments.length"
        :items="transformDocuments(operationsDocuments)"
        class="mb-4"
      />

      <BaseSectionHeader class="pt-4 border-t border-strong-shadow-color">
        {{ $t('PEA Details') }}
      </BaseSectionHeader>
      <BaseMenuList
        v-if="peaDocuments.length"
        :items="transformDocuments(peaDocuments)"
        class="mb-4"
      />
    </BaseSection>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import loadInvestment from '../mixins/loadInvestment';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseSectionHeader from '../components/BaseSectionHeader.vue';
import BaseMenuList from '../components/BaseMenuList.vue';
import BaseEmptyState from '../components/BaseEmptyState.vue';
import image from '../assets/document.svg';

export default {
  name: 'InvestmentDocuments',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseSectionHeader,
    BaseMenuList,
    BaseEmptyState,
  },
  mixins: [loadInvestment],
  data() {
    return { image };
  },
  computed: {
    ...mapGetters('investment', ['companyAdminDocuments', 'financialStatementDocuments', 'operationsDocuments', 'peaDocuments']),
  },
};
</script>
